import { bootstrapApplication } from '@angular/platform-browser';

import packageJson from '../package.json';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { initializeFaroFromEnvironment } from './app/core/observability/faro-init.util';

initializeFaroFromEnvironment(environment.faro, packageJson.version);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
